<template>
    <DeathData/>
</template>

<script>
import { DeathData } from 'shared'

export default {
    name: 'deathData',
    components: {
        DeathData
    },
    created() {
        this.$store.commit('getDeath', {
            shares: '数字生活',
            a100: '在线教育'
        })
    }
}
</script>